var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22056 3.48089C6.07018 3.11762 5.67371 2.92427 5.29482 3.02778L3.57615 3.49651C3.23632 3.59026 3 3.89884 3 4.25039C3 9.0822 6.9178 13 11.7496 13C12.1012 13 12.4097 12.7637 12.5035 12.4239L12.9722 10.7052C13.0757 10.3263 12.8824 9.92982 12.5191 9.77944L10.6442 8.99822C10.3258 8.86542 9.95673 8.95721 9.73994 9.22478L8.95091 10.1876C7.57597 9.53726 6.46274 8.42403 5.81238 7.04909L6.77522 6.26202C7.04279 6.04328 7.13458 5.6761 7.00178 5.35776L6.22056 3.48284V3.48089Z",
    fill: "#6D738D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ca0048abc1405795a62e607fe6826d99.svg";
export { ForwardRef as ReactComponent };